import { Component, inject } from '@angular/core';
import {
  AuthService,
  CardsService,
  ParserService,
  PostComponent as CorePostComponent,
  PostService,
  PostType,
  SettingsService,
} from '@gallaghercp/core-frontend';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Component({
  selector: 'core-post',
  templateUrl: './post.component.html',
  standalone: false,
})
export class PostComponent extends CorePostComponent {
  protected override route: ActivatedRoute;
  protected override router: Router;
  protected override posts: PostService;
  protected override auth: AuthService;
  protected override titleService: Title;
  protected override metaTagService: Meta;
  protected override parser: ParserService;
  protected override settings: SettingsService;
  protected cards = inject(CardsService);

  latestArticles$!: Observable<any>;

  constructor() {
    const route = inject(ActivatedRoute);
    const router = inject(Router);
    const posts = inject(PostService);
    const auth = inject(AuthService);
    const titleService = inject(Title);
    const metaTagService = inject(Meta);
    const parser = inject(ParserService);
    const settings = inject(SettingsService);

    super(route, router, posts, auth, titleService, metaTagService, parser, settings);

    this.route = route;
    this.router = router;
    this.posts = posts;
    this.auth = auth;
    this.titleService = titleService;
    this.metaTagService = metaTagService;
    this.parser = parser;
    this.settings = settings;
  }

  override ngOnInit() {
    super.ngOnInit();
    this.latestArticles$ = this.cards.getCards(CardsService.LATEST_ARTICLES, false, 6, 0);
  }

  filteredArticles(articles: { body: PostType[] }): PostType[] {
    return articles.body.filter((post: PostType) => post.id !== this.posts.getCurrentPost()?.id);
  }
}
